module.exports = __webpack_public_path__ + "static/media/blueMutagen.d08551f2.png";